<div class="m-2">
  <div class="modal-header text-center">
    <h4 class="modal-title">{{title}}</h4>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label" for="breedTypeahead">Select or type breed</label>
      <input
        #breedInput="ngModel"
        #breedTypeahead="ngbTypeahead"
        class="form-control"
        [class.is-invalid]="breedInput.touched && breedInput.invalid"
        id="breedTypeahead"
        name="breedTypeahead"
        [(ngModel)]="selectedBreed"
        [ngbTypeahead]="searchBreed"
        [editable]="false"
        [resultFormatter]="formatter"
        [inputFormatter]="formatter"
        placeholder="Select {{petSpecie}} breed"
        (focus)="focus$.next($any($event).target.value)"
        (click)="click$.next($any($event).target.value)"
        required
        type="text"
      />
      <div *ngIf="breedInput.invalid && breedInput.touched" class="invalid-feedback">
        Please select a breed from the list
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center text-center">
    <button 
      type="button" 
      class="btn btn-lg btn-secondary text-white modal-button" 
      (click)="onSubmit()"
      [disabled]="!selectedBreed"
    >
      Next
    </button>
  </div>
</div>
